import { useEffect } from 'react';

export const AdobeAnalyticsHead = () => {
  return (
    <script src="https://components2.gazzettaobjects.it/rcs_tealium/v1/distro/gazzetta/prod/utag.sync.js"></script>
  );
};

export const AdobeAnalyticsBody = () => {
  useEffect(() => {
    window.utag_data = {};

    const scriptSrc = 'https://components2.gazzettaobjects.it/rcs_tealium/v1/distro/gazzetta/prod/utag.js';
    const existingScript = document.querySelector(`script[src="${scriptSrc}"]`);

    if (existingScript) return;

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = scriptSrc;
    script.onload = () => {
      if (typeof window.utag_data.send_page_bottom === 'function') {
        window.utag_data.send_page_bottom();
      }
    };

    document.head.appendChild(script);
  }, []);

  return null;
};
